module.exports = __webpack_public_path__ + "img/default-avatar.5916c05a.png";